'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

export function Congratulations() {
  const { t } = useTranslations();

  return (
    <div className={cn('custom-section', 'py-12 sm:py-16 lg:py-24 xl:py-32')}>
      <div className={cn('custom-container', 'flex flex-col items-center justify-center gap-12')}>
        <Image src={'/images/icons/thank-you.svg'} alt={t('text643')} width={104} height={104} />
        <div className="flex w-full flex-col items-center justify-center gap-4 sm:gap-5 lg:gap-6">
          <h4 className="w-full max-w-[700px] text-center text-3xl font-normal tracking-tighter sm:text-4xl">
            {t('text2029')}
          </h4>
          <p className="max-w-[700px] text-center text-sm font-normal tracking-tight sm:text-base">
            {t('text2030')}
          </p>
        </div>
        <Button asChild variant={'dark'}>
          <Link prefetch={false} href={ROUTES.HOME()}>
            {t('text2031')}
          </Link>
        </Button>
      </div>
    </div>
  );
}
